import React from "react";
import LogoImage from "./Group.png";
const Logo = (props) => {
  return <img alt="Logo" src={LogoImage} {...props} />;
};

export default Logo;
